var $866555b31f2d7711$exports = {};
$866555b31f2d7711$exports = {
  "decrease": function decrease(args) {
    return "Riduci ".concat(args.fieldLabel);
  },
  "increase": function increase(args) {
    return "Aumenta ".concat(args.fieldLabel);
  },
  "numberField": "Campo numero"
};
export { $866555b31f2d7711$exports as default };